import {
    FETCH_PROPERTIES_CONTENT,
    FETCH_PROPERTIES_CONTENT_SUCCESS,
    FETCH_PROPERTIES_CONTENT_FAILED,
    PROPERTIES_DELETE__MESSAGE,
    PROPERTIES_DELETE_MESSAGE_SUCCESS,
    PROPERTIES_DELETE__MESSAGE_FAILED
} from "../actions/actionTypes";

const initialState = {
    isLoading: true,
    content: {},
    error: false,
    isFormProcessing: false,
    emptyFormData: false,
};

export default function (state = initialState, { type, payload }) {

    switch (type) {
        case FETCH_PROPERTIES_CONTENT:
            return {
                ...state,
                isLoading: true,
                content: {},
            };
        case FETCH_PROPERTIES_CONTENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                content: payload,
            };
        case FETCH_PROPERTIES_CONTENT_FAILED:
            return {
                ...state,
                isLoading: false,
                error: payload,
            };
        case PROPERTIES_DELETE__MESSAGE:
            return {
                ...state,
                isFormProcessing: true,
            };
        case PROPERTIES_DELETE_MESSAGE_SUCCESS:
            return {
                ...state,
                isFormProcessing: false,
                emptyFormData: true
            };
        case PROPERTIES_DELETE__MESSAGE_FAILED:
            return {
                ...state,
                isFormProcessing: false,
                error: payload
            };
        default:
            return state;
    }
}
